"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.coerceValueToQuillDeltas = coerceValueToQuillDeltas;
function coerceValueToQuillDeltas(maybeDelta) {
    if (!maybeDelta) {
        return [];
    }
    try {
        return JSON.parse(maybeDelta);
    }
    catch (_e) {
        // Not a delta
    }
    return [
        {
            insert: maybeDelta,
        },
    ];
}
/**
 * @todo: consider using the official parser instead of maintaining our own
 * https://github.com/slab/delta
 *
 * @param mightBeDelta String of quill deltas (JSON encoded array of quill operations)
 * @returns String representation of parsed quill deltas
 */
const getTextFromQuillDeltas = (mightBeDelta) => {
    if (mightBeDelta) {
        if (mightBeDelta.startsWith('[') && mightBeDelta.endsWith(']')) {
            const deltas = JSON.parse(mightBeDelta);
            let lines = [];
            deltas.forEach((delta, index) => {
                if (typeof delta.insert !== 'string')
                    return;
                lines.push(delta.insert);
                if (delta.attributes?.list === 'ordered') {
                    const lastNewLineIndexInLines = lines.findLastIndex((line) => line.includes('\n'));
                    const lastNewLineIndexInDeltas = deltas
                        .slice(0, index)
                        .findLastIndex((delta) => delta.insert.includes('\n'));
                    const number = deltas
                        .slice(lastNewLineIndexInDeltas, index)
                        .reduce((acc, delta) => {
                        if (delta.attributes?.list) {
                            acc++;
                        }
                        return acc;
                    }, 1);
                    lines = [
                        ...lines.slice(0, lastNewLineIndexInLines - 1),
                        `${number}. `,
                        ...lines.slice(lastNewLineIndexInLines - 1),
                    ];
                }
                else if (delta.attributes?.list === 'bullet') {
                    const lastNewLineIndex = lines.findLastIndex((line) => line.includes('\n'));
                    lines = [
                        ...lines.slice(0, lastNewLineIndex - 1),
                        '- ',
                        ...lines.slice(lastNewLineIndex - 1),
                    ];
                }
            });
            return lines.join('');
        }
        return mightBeDelta;
    }
    return '';
};
exports.default = getTextFromQuillDeltas;
//# sourceMappingURL=quill-delta.js.map